import moment from "moment";
import React, { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner, Table } from "reactstrap";
import { QRCodeSVG } from "qrcode.react";

export const ButtonPrintF4 = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

const cellStyle = {
  border: "1px solid black",
  padding: "4px",
  height: "14px",
  textAlign: "center",
  verticalAlign: "top",
  wordWrap: "break-word",
};

export const PrintDocF4 = ({ innerRef, item, type }) => {
  const validValue = (val) => {
    return <span className="courier-prime-bold text-capitalize">{`${val || "..................."}`}</span>;
  };

  const handleValidDate = (date) => {
    return moment(date).format("D MMMM YYYY");
  };
  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }
  // const svgElement = document.querySelector("#qrcode-container svg");
  // const svgString = new XMLSerializer().serializeToString(svgElement);
  // const base64Svg = `data:image/svg+xml;base64,${btoa(svgString)}`;

  return !item || item === undefined || item === null ? (
    <></>
  ) : (
    <div
      // className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      {/* ///1/// */}
      {type === "print-siteplan" && (
        <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px", fontSize: "12px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ marginTop: "10px" }}>
              <div>Lampiran : </div>
              <div>{`Perihal : Pengesahan Siteplan`}</div>
            </div>
            <div style={{ marginTop: "10px" }}>
              <div>Melalui</div>
              <div>Kepala Dinas Pekerjaan Umum dan Penataan</div>
              <div>{`Ruang Kabupaten Bogor`}</div>
              <div>
                {`di `}
                {validValue(item?.kecamatan)}
              </div>
            </div>
          </div>

          <div>Yang Bertanda tangan di bawah ini :</div>

          <table style={{ borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ width: "120px" }}>Nama</td>
                <td style={{ width: "15px" }}>:</td>
                <td>{validValue(item?.nama)}</td>
              </tr>
              <tr>
                <td>Jabatan</td>
                <td>:</td>
                <td>{validValue(item?.jabatan)}</td>
              </tr>
              <tr>
                <td>Alamat</td>
                <td>:</td>
                <td>{validValue(item?.alamat)}</td>
              </tr>
            </tbody>
          </table>

          <div style={{ marginTop: "10px" }}>
            Dengan ini saya mengajukan permohonan Pengesahan Site Plan atas nama <span>{validValue(item?.atas_nama)}</span> untuk kegiatan <span>{validValue(item?.kegiatan)}</span> di atas tanah seluas <span>{validValue(item?.luas_tanah)}</span> M² yang terletak di Desa/Kelurahan <span>{validValue(item?.desa)}</span> Kecamatan <span>{validValue(item?.kecamatan)}</span> Kabupaten Bogor
          </div>

          <div style={{ marginTop: "10px" }}>Sebagai bahan pertimbangan terlampir disampaikan kelengkapan berkas sebagai berikut :</div>

          <ol style={{ paddingLeft: "15px", lineHeight: "1.5", marginTop: "5px" }}>
            <li>Fotokopy KTP Pemohon.</li>
            <li>Fotokopy NPWP.</li>
            <li>
              Fotokopy Akta Perusahaan dan pengesahan dari Menteri yang berwenang <i>(bagi pemohon Badan Hukum)</i>.
            </li>
            <li>Surat kuasa pemohon diatas materai cukup, apabila dikuasakan.</li>
            <li>Fotokopy tanda lunas PBB tahun terakhir.</li>
            <li>Fotokopy Izin Lokasi / Penetapan Lokasi / Penetapan Status Penggunaan Tanah / Izin Penggunaan Tanah, atau Bukti Perolehan Tanah melalui konsolidasi.</li>
            <li>Fotokopy Bukti Kepemilikan Tanah dalam bentuk sertipikat atau bukti perolehan/peralihan/penguasaan hak atas tanah (rekapitulasi ditandatangani pemohon terlampir).</li>
            <li>Fotokopi Peta Bidang Tanah dan Monitoring Rincian Tanah dalam gambar hasil ukur dari Kantor Pertanahan.</li>
            <li>Draft gambar dengan format baku disajikan dalam bentuk Hardcopy dan Softcopy (Digital) skala* 1 : 2000, 1 : 1000, 1 : 500 atau 1 : 200.</li>
            <li>Sketsa Menuju Lokasi.</li>
          </ol>

          <div style={{ marginTop: "10px" }}>Demikian permohonan ini disampaikan, atas bantuan dan perhatiannya saya ucapkan terima kasih.</div>

          <div
            style={{
              display: "flex",
              justifyContent: "end",
            }}
          >
            <div style={{ marginTop: "40px", textAlign: "center" }}>
              <div>Hormat Saya,</div>
              <div style={{ marginTop: "80px", fontWeight: "bold" }}>{validValue(item?.nama)}</div>
              <div style={{ fontWeight: "bold" }}>{validValue(item?.jabatan)}</div>
            </div>
          </div>

          <div style={{ marginTop: "10px" }}>
            Nama dan Nomor Telepon yang dapat dihubungi : <span>{validValue(item?.telpon)}</span> dan email yang aktif <span>{validValue(item?.email)}</span>
          </div>

          <div style={{ marginTop: "10px" }}>Tembusan :</div>
          <ol style={{ paddingLeft: "15px", lineHeight: "1.5", marginTop: "5px" }}>
            <li>Yth. Sekertaris Daerah melalui Kepala Bagian Perundang-Undangan Kabupaten Bogor;</li>
            <li>Yth. Kepala Dinas Perumahan, Kawasan Pemukiman dan Pertanahan Kabupaten Bogor;</li>
          </ol>
          <div style={{ marginTop: "10px", fontStyle: "italic" }}>*Coret yang tidak perlu</div>
        </div>
      )}

      {/* // peli banjir*/}
      {type === "print-peli-banjir" && (
        <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px", fontSize: "12px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ marginTop: "10px" }}>
              <div>Nomor : {validValue(item?.no_lampiran)}</div>
              <div>Lampiran : 1 berkas</div>
              <div>{`Perihal : Permohonan Rekomendasi Peli Banjir`}</div>
            </div>
            <div style={{ marginTop: "10px" }}>
              <td>{validValue(item?.tanggal)}</td>
              <div>Kepada Yth.</div>
              <div>Kepala Dinas Pekerjaan Umum dan Penataan</div>
              <div>{`Ruang Kabupaten Bogor`}</div>
              <div>
                {`di `}
                {validValue(item?.kecamatan)}
              </div>
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ width: "20px" }}>A.</div>
            <div>Yang Bertanda tangan di bawah ini :</div>
          </div>

          <table style={{ marginLeft: "20px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ width: "120px" }}>Nama</td>
                <td style={{ width: "15px" }}>:</td>
                <td>{validValue(item?.nama)}</td>
              </tr>
              <tr>
                <td>Perusahaan</td>
                <td>:</td>
                <td>{validValue(item?.perusahaan)}</td>
              </tr>
              <tr>
                <td>Jabatan</td>
                <td>:</td>
                <td>{validValue(item?.jabatan)}</td>
              </tr>
              <tr>
                <td>Alamat</td>
                <td>:</td>
                <td>{validValue(item?.alamat)}</td>
              </tr>
            </tbody>
          </table>

          <div style={{ marginTop: "10px", display: "flex", alignItems: "center" }}>
            <div style={{ width: "20px" }}>B.</div>
            <div>Tanah/Lokasi yang di mohon</div>
          </div>

          <table style={{ marginLeft: "20px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ width: "120px" }}>Ruas Jalan</td>
                <td style={{ width: "15px" }}>:</td>
                <td>{validValue(item?.ruas_jalan)}</td>
              </tr>
              <tr>
                <td>Desa/Kelurahan</td>
                <td>:</td>
                <td>{validValue(item?.desa)}</td>
              </tr>
              <tr>
                <td>Kecamatan</td>
                <td>:</td>
                <td>{validValue(item?.kecamatan)}</td>
              </tr>
              <tr>
                <td>Kabupaten</td>
                <td>:</td>
                <td>Bogor</td>
              </tr>
              <tr>
                <td>Luas Pemakaian</td>
                <td>:</td>
                <td>{validValue(item?.luas_tanah)}M²</td>
              </tr>
            </tbody>
          </table>

          <div style={{ marginTop: "10px", display: "flex", alignItems: "center" }}>
            <div style={{ width: "20px" }}>C.</div>
            <div>Persyaratan yang di lampirkan</div>
          </div>

          <ol style={{ paddingLeft: "20px", lineHeight: "1.5", marginTop: "5px", listStyle: "none" }}>
            <li>➤ Fotocopy KTP</li>
            <li>➤ Surat Pernyataan/Surat Kuasa bermaterai Rp. 10000,- (apabila di wakilkan / dikuasakan)</li>
            <li>➤ IPPT/ILOK/PKKPR/KKPR</li>
            <li>➤ PERTEK BPN</li>
            <li>➤ Peta Bidang Tanah</li>
            <li>➤ Ijin Lingkungan</li>
            <li>➤ Draft Site Plan</li>
            <li>➤ Soft Copy Kontur Tanah (Topografi)</li>
          </ol>

          <div style={{ marginTop: "10px" }}>Demikian atas perhatiannya diucapkan banyak terima kasih.</div>

          <div
            style={{
              display: "flex",
              justifyContent: "end",
            }}
          >
            <div style={{ marginTop: "40px", textAlign: "center" }}>
              <div>Pemohon,</div>
              <div style={{ marginTop: "80px", fontWeight: "bold" }}>{validValue(item?.nama)}</div>
            </div>
          </div>
        </div>
      )}

      {type === "print-jembatan" && (
        <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px", fontSize: "12px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ marginTop: "10px" }}>
              <div>Nomor : {validValue(item?.no_lampiran)}</div>
              <div>Lampiran : 1 berkas</div>
              <div>{`Perihal : Permohonan Rekomendasi Jembatan`}</div>
            </div>
            <div style={{ marginTop: "10px" }}>
              <td>{validValue(item?.tanggal)}</td>
              <div>Kepada Yth.</div>
              <div>Kepala Dinas Pekerjaan Umum dan Penataan</div>
              <div>{`Ruang Kabupaten Bogor`}</div>
              <div>
                {`di `}
                {validValue(item?.kecamatan)}
              </div>
            </div>
          </div>

          <div>Yang Bertanda tangan di bawah ini :</div>

          <table style={{ borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ width: "120px" }}>Nama</td>
                <td style={{ width: "15px" }}>:</td>
                <td>{validValue(item?.nama)}</td>
              </tr>
              <tr>
                <td>Nama Perusahaan</td>
                <td>:</td>
                <td>{validValue(item?.perusahaan)}</td>
              </tr>
              <tr>
                <td>Jabatan</td>
                <td>:</td>
                <td>{validValue(item?.jabatan)}</td>
              </tr>
              <tr>
                <td>Alamat</td>
                <td>:</td>
                <td>{validValue(item?.alamat)}</td>
              </tr>
            </tbody>
          </table>

          <div style={{ marginTop: "10px" }}>
            &nbsp;&nbsp;&nbsp;&nbsp;Dengan ini mohon bantuannya untuk dapat memberikan Rekomendasi Jembatan untuk pembuatan jembatan akses keluar - masuk <span>{validValue(item?.akses_keluar_masuk)}</span> atas nama <span>{validValue(item?.atas_nama)}</span> yang berlokasi di Desa/Kel <span>{validValue(item?.desa)}</span> Kecamatan <span>{validValue(item?.kecamatan)}</span> Kabupaten Bogor
          </div>

          <div style={{ marginTop: "10px" }}>Sebagai bahan pertimbangan kami lampirkan data - data sebagai berikut :</div>

          <ol style={{ paddingLeft: "15px", lineHeight: "1.5", marginTop: "5px" }}>
            <li>Fotokopy KTP.</li>
            <li>Denah lokasi/Peta bidang tanah.</li>
            <li>Gambar jembatan dan perhitungan kontruksi.</li>
            <li>Hasil sondir tanah.</li>
            <li>SK. ILOK/IPPT</li>
            <li>sertifikat Tanah/AJB</li>
            <li>Draft Siteplan/Peta Situasi</li>
          </ol>

          <div style={{ marginTop: "10px" }}>Demikian permohonan ini disampaikan, atas bantuan dan perhatiannya saya ucapkan terima kasih.</div>

          <div
            style={{
              display: "flex",
              justifyContent: "end",
            }}
          >
            <div style={{ marginTop: "40px", textAlign: "center" }}>
              <div>Pemohon,</div>
              <div style={{ marginTop: "80px", fontWeight: "bold" }}>{validValue(item?.nama)}</div>
            </div>
          </div>
        </div>
      )}

      {type === "print-rumija" && (
        <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px", fontSize: "12px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ border: "1px solid black", padding: "10px", fontWeight: "bold", fontSize: "14px" }}>BARU</div>
            <div style={{ border: "1px solid black", padding: "10px", fontWeight: "bold", fontSize: "14px" }}>F04a-DAMIJA</div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ marginTop: "10px" }}>
              <table style={{ width: "300px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "50px", verticalAlign: "top" }}>Perihal</td>
                    <td style={{ width: "15px", verticalAlign: "top" }}>:</td>
                    <td>Permohonan Izin Pemakaian Tanah Ruang Milik Jalan (RUMIJA) </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style={{ marginTop: "10px" }}>
              <div>Kepada Yth.</div>
              <div>Bupati Bogor</div>
              <div>Up. Kepala Dinas Penanaman Moda</div>
              <div>Dan Pelayanan Terpadu Satu Pintu</div>
              <div>{`Ruang Kabupaten Bogor`}</div>
              <div>
                {`di `}
                {validValue(item?.kecamatan)}
              </div>
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ width: "20px" }}>A.</div>
            <div>Yang Bertanda tangan di bawah ini :</div>
          </div>

          <table style={{ marginLeft: "20px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ width: "120px" }}>Nama</td>
                <td style={{ width: "15px" }}>:</td>
                <td>{validValue(item?.nama)}</td>
              </tr>
              <tr>
                <td>Alamat</td>
                <td>:</td>
                <td>{validValue(item?.alamat)}</td>
              </tr>
              <tr>
                <td>Perusahaan</td>
                <td>:</td>
                <td>{validValue(item?.perusahaan)}</td>
              </tr>
              <tr>
                <td>Alamat</td>
                <td>:</td>
                <td>{validValue(item?.alamat_perusahaan)}</td>
              </tr>
            </tbody>
          </table>

          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ width: "20px" }}>B.</div>
            <div>Tanah yang dimohon</div>
          </div>

          <table style={{ marginLeft: "20px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ width: "20px", verticalAlign: "top" }}>1.</td>
                <td style={{ width: "80px", verticalAlign: "top" }}>Lokasi</td>
                <td style={{ width: "20px", verticalAlign: "top" }}></td>
                <td>
                  <table style={{ borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
                    <tbody>
                      <tr>
                        <td style={{ width: "120px" }}>Ruas Jalan</td>
                        <td style={{ width: "20px" }}>:</td>
                        <td>{validValue(item?.ruas_jalan)}</td>
                      </tr>
                      <tr>
                        <td>Desa/Kelurahan*</td>
                        <td>:</td>
                        <td>{validValue(item?.desa)}</td>
                      </tr>
                      <tr>
                        <td>Kecamatan</td>
                        <td>:</td>
                        <td>{validValue(item?.kecamatan)}</td>
                      </tr>
                      <tr>
                        <td>Luas Pemakaian</td>
                        <td>:</td>
                        <td>{validValue(item?.luas_tanah)}M²</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <table style={{ marginLeft: "20px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ width: "20px", verticalAlign: "top" }}>2.</td>
                <td style={{ width: "221px", verticalAlign: "top" }}>Rencana Penggunaan</td>
                <td style={{ width: "20px", verticalAlign: "top" }}>:</td>
                <td>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <input
                        disabled
                        type="checkbox"
                        style={{
                          appearance: "none",
                          WebkitAppearance: "none",
                          width: "16px",
                          height: "16px",
                          border: "2px solid black",
                          borderRadius: "0px",
                          backgroundColor: "white",
                          position: "relative",
                        }}
                      />
                      Jalan Masuk
                    </label>
                    <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <input
                        disabled
                        type="checkbox"
                        style={{
                          appearance: "none",
                          WebkitAppearance: "none",
                          width: "16px",
                          height: "16px",
                          border: "2px solid black",
                          borderRadius: "0px",
                          backgroundColor: "white",
                          position: "relative",
                        }}
                      />{" "}
                      Galian
                    </label>
                    <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <input
                        disabled
                        type="checkbox"
                        style={{
                          appearance: "none",
                          WebkitAppearance: "none",
                          width: "16px",
                          height: "16px",
                          border: "2px solid black",
                          borderRadius: "0px",
                          backgroundColor: "white",
                          position: "relative",
                        }}
                      />{" "}
                      Reklame
                    </label>
                  </div>
                </td>
              </tr>
              <tr>
                <td style={{ width: "20px", verticalAlign: "top" }}>3.</td>
                <td style={{ width: "221px", verticalAlign: "top" }}>Jenis Penggunaan Tanah Sekarang</td>
                <td style={{ width: "20px", verticalAlign: "top" }}>:</td>
                <td>{validValue(item?.jenis_penggunaan_tanah)}</td>
              </tr>
            </tbody>
          </table>

          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ width: "20px" }}>C.</div>
            <div>Persyaratan yang dilampirkan :</div>
          </div>

          <div>
            {/* Header */}
            <div style={{ display: "flex", alignItems: "flex-start", marginBottom: "5px" }}>
              <div style={{ display: "flex", gap: "8px", marginLeft: "24px" }}>
                <div
                  style={{
                    border: "1px solid black",
                    padding: "5px 10px",
                  }}
                >
                  FO
                </div>
                <div
                  style={{
                    border: "1px solid black",
                    padding: "5px 10px",
                  }}
                >
                  BO
                </div>
              </div>
            </div>

            {/* List */}
            <ol style={{ paddingLeft: "24px", lineHeight: "1.5" }}>
              <li style={{ display: "flex", marginBottom: "5px" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginLeft: "12px", marginRight: "30px" }}>
                  <div style={{ display: "flex", gap: "28px" }}>
                    <input
                      disabled
                      type="checkbox"
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        width: "16px",
                        height: "16px",
                        border: "2px solid black",
                        borderRadius: "0px",
                        backgroundColor: "white",
                        position: "relative",
                      }}
                    />
                    <input
                      disabled
                      type="checkbox"
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        width: "16px",
                        height: "16px",
                        border: "2px solid black",
                        borderRadius: "0px",
                        backgroundColor: "white",
                        position: "relative",
                      }}
                    />
                  </div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <div style={{ width: "20px" }}>1.</div>
                    <div style={{ flex: 1, marginLeft: "0px" }}>Fotocopy KTP pemohon (Pemilik/Penanggung Jawab/Direktur) atau Surat Izin Tinggal Sementara/Tetap/KITAS/KITAP), khusus untuk Warga Negara Asing;</div>
                  </div>
                </div>
              </li>

              <li style={{ display: "flex", marginBottom: "5px" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginLeft: "12px", marginRight: "30px" }}>
                  <div style={{ display: "flex", gap: "28px" }}>
                    <input
                      disabled
                      type="checkbox"
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        width: "16px",
                        height: "16px",
                        border: "2px solid black",
                        borderRadius: "0px",
                        backgroundColor: "white",
                        position: "relative",
                      }}
                    />
                    <input
                      disabled
                      type="checkbox"
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        width: "16px",
                        height: "16px",
                        border: "2px solid black",
                        borderRadius: "0px",
                        backgroundColor: "white",
                        position: "relative",
                      }}
                    />
                  </div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <div style={{ width: "20px" }}>2.</div>
                    <div style={{ flex: 1, marginLeft: "0px" }}>Surat Kuasa dan fotocopy KTP penerima kuasa, apabila pengurusan perizinan dikuasakan kepada orang lain;</div>
                  </div>
                </div>
              </li>

              <li style={{ display: "flex", marginBottom: "5px" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginLeft: "12px", marginRight: "30px" }}>
                  <div style={{ display: "flex", gap: "28px" }}>
                    <input
                      disabled
                      type="checkbox"
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        width: "16px",
                        height: "16px",
                        border: "2px solid black",
                        borderRadius: "0px",
                        backgroundColor: "white",
                        position: "relative",
                      }}
                    />
                    <input
                      disabled
                      type="checkbox"
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        width: "16px",
                        height: "16px",
                        border: "2px solid black",
                        borderRadius: "0px",
                        backgroundColor: "white",
                        position: "relative",
                      }}
                    />
                  </div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <div style={{ width: "20px" }}>3.</div>
                    <div style={{ flex: 1, marginLeft: "0px" }}>Fotocopy Akta Pendirian Perusahaan dan atau Akta Perubahannya serta Akta Pengesahannya (Bagi pemohon yang berbadan usaha);</div>
                  </div>
                </div>
              </li>

              <li style={{ display: "flex", marginBottom: "5px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    marginLeft: "12px",
                    marginRight: "30px",
                  }}
                >
                  <div style={{ display: "flex", gap: "28px" }}>
                    <input
                      disabled
                      type="checkbox"
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        width: "16px",
                        height: "16px",
                        border: "2px solid black",
                        borderRadius: "0px",
                        backgroundColor: "white",
                        position: "relative",
                      }}
                    />
                    <input
                      disabled
                      type="checkbox"
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        width: "16px",
                        height: "16px",
                        border: "2px solid black",
                        borderRadius: "0px",
                        backgroundColor: "white",
                        position: "relative",
                      }}
                    />
                  </div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <div style={{ width: "20px" }}>4.</div>
                    <div style={{ flex: 1, marginLeft: "0px" }}>Fotocopy NPWP perusahaan/perorangan;</div>
                  </div>
                </div>
              </li>

              <li style={{ display: "flex", marginBottom: "5px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    marginLeft: "12px",
                    marginRight: "30px",
                  }}
                >
                  <div style={{ display: "flex", gap: "28px" }}>
                    <input
                      disabled
                      type="checkbox"
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        width: "16px",
                        height: "16px",
                        border: "2px solid black",
                        borderRadius: "0px",
                        backgroundColor: "white",
                        position: "relative",
                      }}
                    />
                    <input
                      disabled
                      type="checkbox"
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        width: "16px",
                        height: "16px",
                        border: "2px solid black",
                        borderRadius: "0px",
                        backgroundColor: "white",
                        position: "relative",
                      }}
                    />
                  </div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <div style={{ width: "20px" }}>5.</div>
                    <div style={{ flex: 1, marginLeft: "0px" }}>Surat keterangan tentang NJOP tahun terakhir dari Desa/Kelurahan atau fotocopy SPPT PBB tahun terakhir disekitar lokasi yang dimohon;</div>
                  </div>
                </div>
              </li>

              {/* /// */}

              <li style={{ display: "flex", marginBottom: "5px" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginLeft: "12px", marginRight: "30px" }}>
                  <div style={{ width: "60px" }}>
                    {/* <input disabled type="checkbox"   style={{
                          appearance: "none",
                          WebkitAppearance: "none",
                          width: "16px",
                          height: "16px",
                          border: "2px solid black",
                          borderRadius: "0px",
                          backgroundColor: "white",
                          position: "relative",
                        }}/>
                    <input disabled type="checkbox"   style={{
                          appearance: "none",
                          WebkitAppearance: "none",
                          width: "16px",
                          height: "16px",
                          border: "2px solid black",
                          borderRadius: "0px",
                          backgroundColor: "white",
                          position: "relative",
                        }}/> */}
                  </div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <div style={{ width: "20px" }}>6.</div>
                    <div style={{ flex: 1, marginLeft: "0px" }}>Untuk Pemakaian Jalan Masuk melampirkan :</div>
                  </div>
                </div>
              </li>
              {/* /// */}
              <li style={{ display: "flex", marginBottom: "5px" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginLeft: "12px", marginRight: "50px" }}>
                  <div style={{ display: "flex", gap: "28px" }}>
                    <input
                      disabled
                      type="checkbox"
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        width: "16px",
                        height: "16px",
                        border: "2px solid black",
                        borderRadius: "0px",
                        backgroundColor: "white",
                        position: "relative",
                      }}
                    />
                    <input
                      disabled
                      type="checkbox"
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        width: "16px",
                        height: "16px",
                        border: "2px solid black",
                        borderRadius: "0px",
                        backgroundColor: "white",
                        position: "relative",
                      }}
                    />
                  </div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <div style={{ width: "20px" }}>a.</div>
                    <div style={{ flex: 1, marginLeft: "0px" }}>Fotocopy Izin Pemanfaatan Ruang, antara lain berupa izin lokasi (ILOK), Izin Peruntukan Penggunaan Tanah (IPPT), Penetapan Lokasi, KRK, KKPR/IPR;</div>
                  </div>
                </div>
              </li>
              <li style={{ display: "flex", marginBottom: "5px" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginLeft: "12px", marginRight: "50px" }}>
                  <div style={{ display: "flex", gap: "28px" }}>
                    <input
                      disabled
                      type="checkbox"
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        width: "16px",
                        height: "16px",
                        border: "2px solid black",
                        borderRadius: "0px",
                        backgroundColor: "white",
                        position: "relative",
                      }}
                    />
                    <input
                      disabled
                      type="checkbox"
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        width: "16px",
                        height: "16px",
                        border: "2px solid black",
                        borderRadius: "0px",
                        backgroundColor: "white",
                        position: "relative",
                      }}
                    />
                  </div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <div style={{ width: "20px" }}>b.</div>
                    <div style={{ flex: 1, marginLeft: "0px" }}>Fotocopy Site Plan atau Peta Situasi;</div>
                  </div>
                </div>
              </li>
              <li style={{ display: "flex", marginBottom: "5px" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginLeft: "12px", marginRight: "50px" }}>
                  <div style={{ display: "flex", gap: "28px" }}>
                    <input
                      disabled
                      type="checkbox"
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        width: "16px",
                        height: "16px",
                        border: "2px solid black",
                        borderRadius: "0px",
                        backgroundColor: "white",
                        position: "relative",
                      }}
                    />
                    <input
                      disabled
                      type="checkbox"
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        width: "16px",
                        height: "16px",
                        border: "2px solid black",
                        borderRadius: "0px",
                        backgroundColor: "white",
                        position: "relative",
                      }}
                    />
                  </div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <div style={{ width: "20px" }}>c.</div>
                    <div style={{ flex: 1, marginLeft: "0px" }}>Fotocopy Sertifikat Tanah/SPH/AJB/Perjanjian Sewa-Menyewa/Sejenisnya;</div>
                  </div>
                </div>
              </li>

              {/* /// */}

              <li style={{ display: "flex", marginBottom: "5px" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginLeft: "12px", marginRight: "30px" }}>
                  <div style={{ display: "flex", gap: "28px" }}>
                    <input
                      disabled
                      type="checkbox"
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        width: "16px",
                        height: "16px",
                        border: "2px solid black",
                        borderRadius: "0px",
                        backgroundColor: "white",
                        position: "relative",
                      }}
                    />
                    <input
                      disabled
                      type="checkbox"
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        width: "16px",
                        height: "16px",
                        border: "2px solid black",
                        borderRadius: "0px",
                        backgroundColor: "white",
                        position: "relative",
                      }}
                    />
                  </div>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <div style={{ width: "20px" }}>7.</div>
                    <div style={{ flex: 1, marginLeft: "0px" }}>
                      Melampirkan <b>SURAT PERNYATAAN</b> sesuai dengan jenis permohonan yang diajukan.
                    </div>
                  </div>
                </div>
              </li>
            </ol>
          </div>

          <div style={{ fontWeight: "bold" }}>*Coret yang tidak perlu</div>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
            }}
          >
            <div style={{ marginTop: "40px", textAlign: "center" }}>
              <div>{validValue(item?.tanggal)}</div>
              <div>Pemohon,</div>
              <div style={{ marginTop: "80px", fontWeight: "bold" }}>{validValue(item?.nama)}</div>
            </div>
          </div>
          <div className="pagebreak">
            <style>{`@media print{.pagebreak{page-break-after:always;}}`}</style>
          </div>
          <div
            style={{
              paddingTop: "40px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ fontStyle: "italic", fontWeight: "bold", textDecoration: "underline" }}>jalan Masuk/ Keluar</div>
              <div style={{ border: "1px solid black", padding: "10px", fontWeight: "bold", fontSize: "14px" }}>LF04</div>
            </div>
            <div
              style={{
                textAlign: "center",
                padding: "5px 0",
                textDecoration: "underline",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              SURAT PERNYATAAN
            </div>

            <div>Yang Bertanda tangan di bawah ini :</div>

            <table style={{ borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
              <tbody>
                <tr>
                  <td style={{ width: "120px" }}>Nama</td>
                  <td style={{ width: "15px" }}>:</td>
                  <td>{validValue(item?.nama)}</td>
                </tr>
                <tr>
                  <td>Pekerjaan/Jabatan</td>
                  <td>:</td>
                  <td>{validValue(item?.jabatan)}</td>
                </tr>
                <tr>
                  <td>Alamat</td>
                  <td>:</td>
                  <td>{validValue(item?.alamat)}</td>
                </tr>
              </tbody>
            </table>

            <div style={{ marginTop: "10px" }}>Dalam hal ini bertindak untuk dan atas nama : (Perusahaan)</div>

            <table style={{ borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
              <tbody>
                <tr>
                  <td style={{ width: "120px" }}>Nama Perusahaan</td>
                  <td style={{ width: "15px" }}>:</td>
                  <td>{validValue(item?.perusahaan)}</td>
                </tr>
                <tr>
                  <td>Nomor Akte Notaris</td>
                  <td>:</td>
                  <td>{validValue(item?.no_perusahaan)}</td>
                </tr>
                <tr>
                  <td>Alamat</td>
                  <td>:</td>
                  <td>{validValue(item?.alamat_perusahaan)}</td>
                </tr>
              </tbody>
            </table>

            <div style={{ marginTop: "10px" }}>Sehubungan dengan penggunaan tanah milik Pemerintah Kabupaten Bogor yang dikelola oleh Dinas Pekerjaan Umum dan Penataan Ruang Kabupaten Bogor kepada Kami, dengan ini Kami memberikan pernyataan sebagai berikut :</div>
            <ol style={{ paddingLeft: "15px", lineHeight: "1.5", marginTop: "5px" }}>
              <li>
                Akan mentaati ketentuan-ketentuan dan petunjuk yang diisyaratkan oleh pemberi izin baik yang berlaku umum maupun bersifat khusus.
                <ol type="a" style={{ paddingLeft: "15px", lineHeight: "1.5", marginTop: "5px" }}>
                  <li>
                    Pembuatan Jalan Masuk/Keluar kendaraan dapat dilaksanakan setelah terbit Surat Keputusan <b>Izin Ruang Milik Jalan (RUMIJA)</b>;
                  </li>
                  <li>Panjang trotoar yang elevasinya diturunkan tidak melebihi 6 (enam) meter dan harus lebih rendah dari elevasi tepi aspal yang ada (Jalan Kabupaten) dan harus berpedoman pada gambar rencana;</li>
                  <li>Tidak mengubah kriteria bentuk dan bahan/material trotoar yang ada;</li>
                  <li>
                    Jalan Masuk/Keluar kendaraan dilengkapi bangunan selokan ditutup dengan grill yang melintas <b>saluran air hujan milik jalan</b> tidak dengan plat beton, serta tidak menghalangi kelancaran saluran air;
                  </li>
                  <li>Permukaan jalan masuk lajur transisi dibuat dengan kemiringan minimum 5% diukur dari tepi perkerasan jalan;</li>
                  <li>Segala kerusakan/perubahan yang diakibatkan pelaksanaan pekerjaan merupakan tanggung jawab penerima izin;</li>
                  <li>Pembuat Jalan Masuk/Keluar kendaraan harus sesuai dengan gambar dan rencana yang disetujui oleh Dinas Pekerjaan Umum dan Penataan Ruang Kabupaten Bogor;</li>
                  <li>Penyediaan rambu-rambu (Trafic Light) dan fisik pengaturan lalu lintas disekitar akan menghubungi dinas terkait setempat.</li>
                </ol>
              </li>
              <li>Bersedia dikenakan sanksi, bila ternyata Kami melalaikan kewajiban/melanggar ketentuan sesuai hukum yang berlaku.</li>
            </ol>
            <div style={{ marginTop: "10px" }}>Demikian pernyataan ini Kami buat dan Kami tanda tangani diatas materai secukupnya untuk dipergunakan sebagaimana mestinya.</div>
            <div
              style={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              <div style={{ marginTop: "40px", textAlign: "center" }}>
                <div>{validValue(item?.tanggal)}</div>
                <div>Yang Membuat Pernyataan,</div>
                <div style={{ marginTop: "80px", fontWeight: "bold" }}>{validValue(item?.nama)}</div>
              </div>
            </div>
          </div>
          <div className="pagebreak">
            <style>{`@media print{.pagebreak{page-break-after:always;}}`}</style>
          </div>
          <div
            style={{
              paddingTop: "40px",
            }}
          >
            <div
              style={{
                textAlign: "center",
                padding: "5px 0",
                textDecoration: "underline",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              Surat Pernyataan Kebenaran dan Keabsahan Data
            </div>

            <div style={{ marginTop: "10px" }}>Yang Bertanda tangan di bawah ini :</div>

            <table style={{ borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
              <tbody>
                <tr>
                  <td style={{ width: "120px" }}>Nama</td>
                  <td style={{ width: "15px" }}>:</td>
                  <td>{validValue(item?.nama)}</td>
                </tr>
                <tr>
                  <td>No. KTP</td>
                  <td>:</td>
                  <td>{validValue(item?.ktp)}</td>
                </tr>
                <tr>
                  <td>Jabatan</td>
                  <td>:</td>
                  <td>{validValue(item?.jabatan)}</td>
                </tr>
                <tr>
                  <td>Nama Instansi</td>
                  <td>:</td>
                  <td>{validValue(item?.nama_instansi)}</td>
                </tr>
                <tr>
                  <td>Alamat Instansi</td>
                  <td>:</td>
                  <td>{validValue(item?.alamat_instansi)}</td>
                </tr>
                <tr>
                  <td>Telepon/Fax.</td>
                  <td>:</td>
                  <td>{validValue(item?.telpon)}</td>
                </tr>
              </tbody>
            </table>
            <div style={{ marginTop: "10px" }}>
              Dengan ini menyatakan dengan sesungguhnya bahwa semua informasi yang disampaikan dalam seluruh dokumen serta lampiran-lampirannya ini adalah <b>benar</b> dan <b>sah</b> serta merupakan kesatuan yang tidak dapat dipisahkan.
            </div>
            <div style={{ marginTop: "10px" }}>Apabila dikemudian hari ditemukan dan/atau dibuktikan adanya penipuan/pemalsuan atas informasi yang disampaikan, maka kami bersedia dikenakan sanksi sesuai dengan peraturan dan ketentuan yang berlaku.</div>
            <div style={{ marginTop: "10px" }}>Demikian surat pernyataan kebenaran dan keabsahan data ini dibuat dengan sebenar-benarnya, tanpa ada paksaan dari pihak manapun, dan untuk digunakan sebagaimana mestinya.</div>
            <div
              style={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              <div style={{ marginTop: "40px", textAlign: "center" }}>
                <div>{validValue(item?.jabatan)}</div>
                {/* <div>Pemohon,</div> */}
                <div style={{ marginTop: "80px", fontWeight: "bold" }}>{validValue(item?.nama)}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
